"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverallStatusSection = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../common");
const ReportTable_1 = require("./ReportTable");
const OverallStatusSectionStyled = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${({ $isMobile }) => ($isMobile ? '28px' : '32px')};
	padding: ${({ $isMobile }) => ($isMobile ? '0 16px 28px' : '0')};

	.section-title {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet }) => ($isMobile ? '16px' : $isTablet ? '17px' : '18px')};
		line-height: 140%;
		font-weight: 700;
	}

	.people-summary-panel,
	.section-card {
		border: 1px solid #e4e6ea;
		border-radius: 16px;
		background: #fff;
	}

	.people-summary-panel {
		display: flex;
		flex-wrap: ${({ $isMobile }) => ($isMobile ? 'wrap' : 'nowrap')};
		overflow: hidden;
	}

	.people-summary-item {
		flex: ${({ $isMobile }) => ($isMobile ? '1 1 33.333%' : '1')};
		display: flex;
		align-items: center;
		justify-content: center;
		gap: ${({ $isMobile }) => ($isMobile ? '8px' : '18px')};
		padding: ${({ $isMobile }) => ($isMobile ? '18px 8px' : '24px 18px')};
		flex-wrap: ${({ $isMobile }) => ($isMobile ? 'wrap' : 'nowrap')};
		position: relative;
		min-width: 0;
	}

	.people-summary-item + .people-summary-item::before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 1px;
		height: ${({ $isMobile }) => ($isMobile ? '28px' : '36px')};
		background: #eceef2;
	}

	.people-summary-label {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '15px' : '17px')};
		line-height: 145%;
		font-weight: 700;
		white-space: normal;
		word-break: keep-all;
		text-align: center;
	}

	.people-summary-value {
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet }) => ($isMobile ? '17px' : $isTablet ? '24px' : '28px')};
		line-height: 1.2;
		font-weight: 700;
	}

	.section-card {
		padding: ${({ $isMobile }) => ($isMobile ? '16px 14px' : '18px 18px')};
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.chart-grid {
		display: flex;
		flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
		flex-wrap: wrap;
		gap: 14px;
		align-items: stretch;
	}

	.graph-box,
	.pie-box {
		flex: 1 1 0;
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 10px;
		min-width: 0;
	}

	.chart-title {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '15px' : '16px')};
		line-height: 145%;
		font-weight: 700;
	}

	.chart-shell {
		flex: 1;
		min-width: 0;
		overflow-x: auto;
		overflow-y: hidden;
		-webkit-overflow-scrolling: touch;
	}

	.pie-shell {
		flex: 1;
		padding: ${({ $isMobile }) => ($isMobile ? '12px 10px' : '14px 12px')};
		display: flex;
		align-items: stretch;
	}

	.pie-content {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: ${({ $isMobile }) => ($isMobile ? '20px' : '32px')};
		flex-direction: row;
		width: 100%;
		align-self: flex-start;
	}

	.pie-wrap {
		flex-shrink: 0;
	}

	.pie-legend {
		display: flex;
		flex-direction: column;
		flex: 1;
		gap: 8px;	
	}

	.pie-legend-item {
		display: flex;
		align-items: center;
		gap: 12px;
		justify-content: ${({ $isMobile }) => ($isMobile ? 'space-between' : 'flex-start')};
	}

	.pie-legend-label {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '13px' : '15px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '24px')};
		font-weight: 700;
		white-space: nowrap;
		width: ${({ $isMobile, $isTablet }) => ($isMobile ? '92px' : $isTablet ? '108px' : '120px')};
		flex-shrink: 0;
	}

	.pie-legend-value {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '18px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '22px' : '28px')};
		font-weight: 700;
		white-space: nowrap;
		width: ${({ $isMobile, $isTablet }) => ($isMobile ? '72px' : $isTablet ? '84px' : '96px')};
		flex-shrink: 0;
		text-align: right;
	}

	.table-wrap {
		height: auto;
	}
`;
const renderEmpty = react_1.default.createElement("div", { style: { padding: '24px 0', color: '#8f9298' } }, "\uD45C\uC2DC\uD560 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.");
const OverallChartBlock = react_1.default.memo(({ sectionId, section, isMobile, }) => {
    const pieContentRef = react_1.default.useRef(null);
    const baseHeight = isMobile ? 152 : 164;
    const [graphHeight, setGraphHeight] = react_1.default.useState(baseHeight);
    react_1.default.useLayoutEffect(() => {
        if (!section.distribution) {
            setGraphHeight(baseHeight);
            return;
        }
        const element = pieContentRef.current;
        if (!element)
            return;
        const updateHeight = () => {
            const nextHeight = Math.max(Math.round(element.scrollHeight), baseHeight);
            setGraphHeight(prev => (prev === nextHeight ? prev : nextHeight));
        };
        updateHeight();
        if (typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(updateHeight);
            observer.observe(element);
            return () => observer.disconnect();
        }
        window.addEventListener('resize', updateHeight);
        window.addEventListener('orientationchange', updateHeight);
        return () => {
            window.removeEventListener('resize', updateHeight);
            window.removeEventListener('orientationchange', updateHeight);
        };
    }, [baseHeight, section.distribution?.length]);
    return (react_1.default.createElement("div", { className: "chart-grid" },
        react_1.default.createElement("div", { className: "graph-box" },
            react_1.default.createElement("div", { className: "chart-title" }, section.trendLabel),
            react_1.default.createElement("div", { className: "chart-shell" },
                react_1.default.createElement(common_1.LineGraph, { data: section.trendPoints, height: graphHeight, axisFontSize: isMobile ? 10 : 11, pointLabelFontSize: isMobile ? 11 : 12, edgeInset: isMobile ? 16 : sectionId === 'attendance' ? 32 : 26, minPointSpacing: isMobile ? 32 : 44 }))),
        section.distribution && (react_1.default.createElement("div", { className: "pie-box" },
            react_1.default.createElement("div", { className: "chart-title" }, "\uC120\uD0DD\uACFC\uBAA9 \uC751\uC2DC \uBD84\uD3EC (\uB204\uC801)"),
            react_1.default.createElement("div", { className: "pie-shell" },
                react_1.default.createElement("div", { className: "pie-content", ref: pieContentRef },
                    react_1.default.createElement("div", { className: "pie-wrap" },
                        react_1.default.createElement(common_1.SepratedPieChart, { data: section.distribution, size: isMobile ? 112 : 122, minLabelPercentage: 5 })),
                    react_1.default.createElement("div", { className: "pie-legend" }, section.distribution.map(item => (react_1.default.createElement("div", { key: item.id, className: "pie-legend-item" },
                        react_1.default.createElement("div", { className: "pie-legend-label" }, item.label),
                        react_1.default.createElement("div", { className: "pie-legend-value" }, `${item.value} 명`)))))))))));
});
exports.OverallStatusSection = react_1.default.memo(({ overallData, isMobile, isTablet, isDesktop, }) => (react_1.default.createElement(OverallStatusSectionStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop },
    react_1.default.createElement("section", null,
        react_1.default.createElement("div", { className: "section-title" }, "\uC778\uC6D0 \uD604\uD669"),
        react_1.default.createElement("div", { className: "people-summary-panel" }, overallData.peopleSummary.map(item => (react_1.default.createElement("div", { key: item.id, className: "people-summary-item" },
            react_1.default.createElement("div", { className: "people-summary-label" }, item.label),
            react_1.default.createElement("div", { className: "people-summary-value" }, `${item.value}${item.unit || ''}`)))))),
    ['attendance', 'test', 'assignment'].map(sectionId => {
        const section = overallData.sections[sectionId];
        return (react_1.default.createElement("section", { key: sectionId },
            react_1.default.createElement("div", { className: "section-title" }, section.title),
            react_1.default.createElement("div", { className: "section-card" },
                react_1.default.createElement(OverallChartBlock, { sectionId: sectionId, section: section, isMobile: isMobile }),
                react_1.default.createElement("div", { className: "table-wrap" },
                    react_1.default.createElement(ReportTable_1.ReportTable, { variant: "overall", segment: sectionId, data: section.rows, renderEmpty: renderEmpty, optionalSubjects: section.optionalSubjects })))));
    }))));
